import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "@/App";
import TuitionHistory from "@/components/TuitionHistory";
import { invoiceHistoryEnabled } from "@/lib/featureFlags";

export default function BillingPage() {
  const { user } = useContext(AuthContext) || {};
  // Off per the server (INSTRUCTOR_INVOICE_HISTORY_ENABLED): an old bookmark
  // lands on Home rather than on a page the sidebar no longer offers.
  if (user && !invoiceHistoryEnabled(user)) return <Navigate to="/dashboard" replace />;
  return (
    <div className="mx-auto max-w-[1120px] px-6 pb-32 pt-11 md:px-12" data-testid="billing-page">
      <TuitionHistory />
    </div>
  );
}
